import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Card from '@/components/layout/Card.vue';
var UserItem = /*#__PURE__*/function (_Vue) {
  function UserItem() {
    var _this;
    _classCallCheck(this, UserItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserItem, [].concat(args));
    _defineProperty(_this, "user", void 0);
    return _this;
  }
  _inherits(UserItem, _Vue);
  return _createClass(UserItem);
}(Vue);
__decorate([Prop()], UserItem.prototype, "user", void 0);
UserItem = __decorate([Options({
  components: {
    Card: Card
  }
})], UserItem);
export default UserItem;